import { Icon } from "./Icon.tsx";

/** Plane ("not georeferenced") view toggle icon. */
export function LayoutGridIcon() {
  return (
    <Icon>
      <rect x="3" y="3" width="8" height="8" rx="1" />
      <rect x="13" y="3" width="8" height="8" rx="1" />
      <rect x="3" y="13" width="8" height="8" rx="1" />
      <rect x="13" y="13" width="8" height="8" rx="1" />
    </Icon>
  );
}
